module.exports = __webpack_public_path__ + "static/img/model-bg27.ae62dd3.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/model-bg27.jpg
// module id = r0XJ
// module chunks = 0